import styles from './Trade.module.css';

const TradeBar = ({ product }) => {
    return (<div className={styles.productBar}>
        <a target={"_blank"} rel='noreferrer' download={product.attachment_files[0].server_relative_url.indexOf('application/pdf') >= 0 ? product.title + '.pdf' : product.attachment_files[0].server_relative_url.indexOf('image/png') >= 0 ? product.title + '.png' : product.attachment_files[0].server_relative_url.indexOf('application/zip') ? product.title + '.zip' : product.attachment_files[0].server_relative_url.indexOf('application/x-rar') ? product.title + '.rar' : product.title + '.jpg'} href={product.attachment_files[0].server_relative_url} className={styles.textDecorationNone}>
            <div className={styles.productBarWrapper}>
                <div className={styles.productContentItem}>
                    <div className={styles.productBarContent}>
                        {product.title}
                    </div>
                    <div className={styles.productBarContentDate} dangerouslySetInnerHTML={{ __html: product.rich_description }}></div>
                    <div className={styles.productBarContentSmallInfo}>
                        <i className={`fa fa-calendar ${styles.calendarSetItem}`}></i> تاریخ انتشار : {product.publish_date}
                    </div>
                </div>
            </div>
        </a>
    </div>);
}

export default TradeBar;